/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Fragment, useEffect, useState } from "react";
import { Alert } from "reactstrap";
import PropTypes from "prop-types";
import Label from "../../../components/label";
import Atag from "../../../components/anchor";
import moment from "moment";
import { getAgeByYears, getDoctorWillCallYouCustomText, getFormattedMonthDate } from "../../../utils/dateTimeHelper";
import DefaultUserImg from "../../../assets/images/default-picture.png";
import PreviouslyPrescribed from "../../../pages/PreviouslyPrescribed";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "./../../../assets/images/info.png";
import MedicalInfo from "../../../pages/MedicalInfo/MedicalInfo";
import { copyText, formatIHINumberForDisplay, getAddressInOneLine, openUIN } from "../../../utils/common";
import RTPMBtn from "../../../components/RTPMBtn";
import MyHealthRecordBtn from "../../../components/MyHealthRecordBtn";

const ViewAssessmentComponent = props => {

  // For profile picture
  const [assessmentData, setAssessmentData] = useState(null);
  const [patinetPreferredTime, setPatientPreferredTime] = useState("-");
  const [patinetPreferredTime2, setPatientPreferredTime2] = useState("");
  const [anchorElement, setAnchorElement] = useState(null);

  const [isDOBCopied, setIsDOBCopied] = useState(false);
  const [isIHICopied, setIsIHICopied] = useState(false);

  const [showAlert, setShowAlert] = useState({
    isOpen: false,
    message: ""
  });

  const copyPatientDOB = async (dob) => {
    console.log("Copy this detail: ", dob);
    const dobToCopy = await moment(dob, "DD-MM-YYYY").format("DD/MM/YYYY");
    console.log("dobToCopy: ", dobToCopy);
    const isCopied = await copyText(dobToCopy);
    console.log("isCopied: ", isCopied);
    if (isCopied) {
      setIsDOBCopied(true);
      setTimeout(() => {
        closeDOBCopiedAlert();
      }, 5000);
    }
  }

  const closeDOBCopiedAlert = () => {
    setIsDOBCopied(false);
  }

  const copyPatientIHI = async (ihiNumber) => {
    console.log("Copy this detail: ", ihiNumber);
    const ihiToCopy = ihiNumber.replace(/\r?\n/g, "");
    console.log("dobToCopy: ", ihiToCopy);
    const isCopied = await copyText(ihiToCopy);
    console.log("isCopied: ", isCopied);
    if (isCopied) {
      setIsIHICopied(true);
      setTimeout(() => {
        closeIHICopiedAlert();
      }, 5000);
    }
  }

  const closeIHICopiedAlert = () => {
    setIsIHICopied(false);
  }

  const copyTextWithAlert = async (e, textToCopy, alertMsg) => {
    e.stopPropagation();
    const isCopied = await copyText(textToCopy);
    console.log("isCopied: ", isCopied);
    if (isCopied) {
      openAlert(alertMsg);
    }
  }

  const openAlert = async (message) => {
    setShowAlert({
      isOpen: true,
      message: message
    });
    setTimeout(() => {
      closeAlert();
    }, 5000);
  }

  const closeAlert = () => {
    setShowAlert({
      isOpen: false,
      message: ""
    });
  }

  useEffect(() => {
    console.log("GOt data here: ", props.assessmentData);
    setAssessmentData(props.assessmentData);
    console.log({ assessmentData: props.assessmentData });
    if (props.assessmentData) {
      let timeOfContact = "-";
      if (
        moment(
          props.assessmentData.doctorContactByTime,
          moment.ISO_8601
        ).isValid()
      ) {
        timeOfContact = getDoctorWillCallYouCustomText(props.assessmentData.doctorContactByTime);
      } else if (
        props.assessmentData.doctorContactByTime &&
        (props.assessmentData.patinetPreferredTime ||
          props.assessmentData.patientPreferredTime)
      ) {
        timeOfContact =
          props.assessmentData.patinetPreferredTime ||
          props.assessmentData.patientPreferredTime;
      } else if (props.assessmentData.doctorContactByTime) {
        timeOfContact = props.assessmentData.doctorContactByTime;
      }
      let strArr = timeOfContact.split("between")
      if (strArr.length > 1) {
        setPatientPreferredTime(strArr[0] + "between")
        setPatientPreferredTime2(strArr[1])
      } else {
        setPatientPreferredTime(timeOfContact);
      }
    }
  }, [props.assessmentData]);

  return (
    <Fragment>
      {assessmentData && assessmentData.patientId && (
        <div className="col-sm-12 mt-4 accept-is-assessment-left-container">
          <div className="card w-100 p-3">
            <div className="p-0 m-0">
              <div className="float-left">
                <img
                  src={assessmentData.patientId.profilePic?.original || DefaultUserImg}
                  className="user-profile-pic-auto-width"
                  alt="User_IMG"
                />
              </div>
              <div className="assessment-patient-info-div">
                <div className="row p-0 m-0 w-100">
                  <div className="col-sm-8">
                    <Label
                      className="m-0 big patient-name-lbl mr-2"
                      title={`${assessmentData.patientId ? assessmentData.patientId.firstName : 'N/A'}`}
                    />{" "}
                    <Label
                      className="m-0 big patient-name-lbl mr-2 cursor-pointer"
                      title={`${assessmentData.patientId ? assessmentData.patientId.lastName : 'N/A'}`}
                      click={(e) => copyTextWithAlert(e, assessmentData.patientId ? assessmentData.patientId.lastName : '', 'Last Name Copied Successfully')}
                    />{" "}
                    <Label className="m-0 cursor-pointer" title="UIN: " />
                    <Label
                      className="secondary-font m-0 cursor-pointer ml-2 insta-link-orange" click={() => {
                        openUIN(assessmentData.patientId, props.auth.userData ? props.auth.userData.accessToken : '')
                      }}
                      title={assessmentData.patientId.patientId}
                    />
                    <br />
                    <Label
                      className="m-0 cursor-pointer"
                      title={`${assessmentData.patientId ? assessmentData.patientId.gender : 'N/A'}`}
                    />
                    <Label
                      className="m-0 cursor-pointer ml-2"
                      title={assessmentData.patientId
                        ? "DOB: " +
                        getFormattedMonthDate(
                          assessmentData.patientId.dateOfBirth
                        ) +
                        " (" +
                        getAgeByYears(assessmentData.patientId.dateOfBirth) +
                        " years of age)"
                        : ""}
                      click={() => copyPatientDOB(assessmentData.patientId.dateOfBirth)}

                    />
                    <br />
                    <Label
                      className="m-0 mt-1"
                      title={assessmentData.patientId
                        ? getAddressInOneLine(assessmentData.patientId.address) : 'N/A'}
                    />
                  </div>
                  <div className="col-sm-4 text-right">
                    <MyHealthRecordBtn />
                    <RTPMBtn state={assessmentData.patientId && assessmentData.patientId.address ? assessmentData.patientId.address.state : ''} className="" />
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="row pr-3">
            <div className="col-sm-4 pr-0">
              <div className="card w-100 mt-3 p-2">
                <div className="row">
                  <div className="col-sm-12">
                    <Label className="m-0 cursor-pointer mr-1" title="Assessment ID:" />
                    <Label
                      className="secondary-font m-0 cursor-pointer"
                      title={assessmentData.appointmentId}
                    />
                  </div>
                  <div className="col-sm-12">
                    <Label className="m-0 cursor-pointer mr-1" title="Billing Type: " />
                    <Label
                      className="secondary-font m-0 cursor-pointer"
                      title={assessmentData.isBulkBilled ? "Medicare" : "Private"}
                    />
                  </div>
                  <div className="col-sm-12 mt-1">
                    <Atag
                      title="Download Online Assessment"
                      href={assessmentData.assessmentPDF}
                      className="insta-link-orange mr-3 thin-font font-15"
                      target="_blank"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4 pr-0">
              <div className="card w-100 mt-3 p-2">
                <div className="row">
                  <div className="col-sm-12">
                    <Label className="m-0 cursor-pointer mr-1" title="Mobile No:" />
                    {assessmentData.patientId &&
                      assessmentData.patientId.phoneNumber ? (
                      <Label
                          className="secondary-font m-0 cursor-pointer"
                        title={
                          assessmentData.patientId.phoneNumber.length > 10
                            ? `${assessmentData.patientId.phoneNumber}`
                            : `${assessmentData.patientId.phoneNumber.slice(0, 4)} ${assessmentData.patientId.phoneNumber.slice(4, 7)} ${assessmentData.patientId.phoneNumber.slice(7, 10)}`
                        }
                          // title={`${assessmentData.patientId.phoneNumber.slice(0, 4)} ${assessmentData.patientId.phoneNumber.slice(4, 7)} ${assessmentData.patientId.phoneNumber.slice(7, 10)}`}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-12 mt-1">
                    <div className="d-flex"> 
                      <p className="mb-0 black-light-font-color">Contact:&nbsp;</p>
                      <div className="d-flex flex-column black-light-font-color">
                        <p className="mb-0 bold-font black-light-font-color">{`${patinetPreferredTime}`}{!patinetPreferredTime2 && (` AEST`)}</p>
                        {patinetPreferredTime2 && (<p className="mb-0 bold-font black-light-font-color">{`${patinetPreferredTime2} AEST`}</p>)}
                      </div>
                    </div>
                    {/* <p className="mb-0">
                      <span className="insta-label">
                        Contact:&nbsp;&nbsp;
                      </span>
                      <span className="insta-label secondary-font font-14">
                        {`${patinetPreferredTime} AEST`}
                      </span>
                    </p> */}
                    {/* <Label className="m-0 cursor-pointer mr-1" title="Contact: " /> */}
                    {/* <Label
                      className="secondary-font m-0"
                      title={ + " AEST"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4 pr-0">
              <div className="card w-100 mt-3 p-2">
                <div className="row">
                  <div className="col-sm-12">
                    <Label className="m-0 mr-1" title="Medicare Number:" />
                    <Label
                      className="secondary-font m-0 cursor-pointer"
                      title={assessmentData.patientId && assessmentData.patientId.medicareNumber ? `${assessmentData.patientId.medicareNumber}` : 'N/A'}
                      click={(e) => copyTextWithAlert(e, assessmentData.patientId && assessmentData.patientId.medicareNumber ? `${(assessmentData.patientId.medicareNumber + assessmentData.patientId.refNumerOnMedicareCard).replace(/\s+/g, "")}` : '', 'Medicare Number with IRN Copied Successfully')}
                    />
                  </div>
                  <div className="col-sm-12">
                    <Label className="m-0 cursor-pointer mr-1" title="Ref Number:" />
                    <Label
                      className="secondary-font m-0"
                      title={assessmentData.patientId && assessmentData.patientId.medicareNumber ? `${assessmentData.patientId.refNumerOnMedicareCard}` : 'N/A'}
                    />
                  </div>
                  <div className="col-sm-12 mt-1">
                    <Label className="m-0 mr-1" title="IHI Number: " />
                    <Label
                      className="secondary-font m-0 cursor-pointer"
                      title={`${assessmentData.patientId && assessmentData.patientId.IHIInfo && assessmentData.patientId.IHIInfo.IHINumber ? formatIHINumberForDisplay(assessmentData.patientId.IHIInfo.IHINumber) : 'N/A'}`}
                      click={() => copyPatientIHI(assessmentData.patientId && assessmentData.patientId.IHIInfo ? assessmentData.patientId.IHIInfo.IHINumber : '')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card w-100 p-3 mt-3">
                            <Label
                                className="m-0 large"
                                title="Attachments: "
                            />
                            <div className="row">
                                {
                                    assessmentData.attachments.map((value, index) => {
                                        return (
                                            <ShowAttachmentComponent key={index} url={value}></ShowAttachmentComponent>
                                        )
                                    })
                                }
                                {
                                    !assessmentData.attachments.length && (
                                        <div className="col-sm-12">
                                            <p className="p-0 m-0">No attachments found</p>
                                        </div>
                                    )
                                }
                            </div>
                        </div> */}

          <div className="card w-100 p-3 mt-3">
            <Label
              className="m-0 large w-100"
              title="Additional Information: "
            />
            <Label
              className="m-0 w-100"
              title={
                assessmentData.additionalInfo
                  ? assessmentData.additionalInfo
                  : "-"
              }
            />
          </div>

          {assessmentData.patientId &&
            <div className="card mb-4 p-2 mt-3">
              <div className="row">
                <div className="col-sm-12">

                  <Label
                    className="prescription-text font-15 pl-4 pt-2 pb-0 pr-1 font-15 secondary-font"
                    title="Previously Prescribed"
                  />

                  <img
                    alt="Medical Info"
                    src={InfoIcon} className="p-1 prev-prescribe-info-edit"
                    onMouseEnter={(e) => setAnchorElement(e.target)}
                    // style={{ width: "22px", height: "22px", marginTop: "4px" }}
                  />
                </div>

                {anchorElement && <Popover disableRestoreFocus anchorOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }} transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }} anchorEl={anchorElement} open={anchorElement} disablePortal>
                  <div onPointerLeave={() => setAnchorElement(null)}>
                    <MedicalInfo patientId={assessmentData.patientId._id} className="col-sm-12 medicalInfo p-4" />
                  </div>
                </Popover>}
              </div>
              <PreviouslyPrescribed email={assessmentData.patientId.email}
                                    patientID={assessmentData.patientId.patientId} />
            </div>
          }
        </div>
      )}

      <Alert color="info" className="alert-position" isOpen={isDOBCopied} toggle={() => closeDOBCopiedAlert()}>
        DOB Copied Successfully
      </Alert>
      <Alert color="info" className="alert-position" isOpen={isIHICopied} toggle={() => closeIHICopiedAlert()}>
        IHI Copied Successfully
      </Alert>
      <Alert color="info" className="alert-position alert-position-patient-detail" isOpen={showAlert.isOpen} toggle={closeAlert}>
        {showAlert.message}
      </Alert>
    </Fragment>
  );
};

export default ViewAssessmentComponent;

ViewAssessmentComponent.defaultProps = {
  serverErrorMsg: ""
};

ViewAssessmentComponent.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
